import { render } from "./TenantManagement.vue?vue&type=template&id=8b8eaeae&scoped=true"
import script from "./TenantManagement.vue?vue&type=script&lang=js"
export * from "./TenantManagement.vue?vue&type=script&lang=js"

import "./TenantManagement.vue?vue&type=style&index=0&id=8b8eaeae&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8b8eaeae"]])

export default __exports__